import { render } from "./PrintLayout.vue?vue&type=template&id=d83c064c"
import script from "./PrintLayout.vue?vue&type=script&lang=js"
export * from "./PrintLayout.vue?vue&type=script&lang=js"

import "./PrintLayout.vue?vue&type=style&index=0&id=d83c064c&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__